export const removeProtocol = (url: string) => url.split('://').reverse()[0]
